export const DEFAULT_SUPPORTED_FILE_EXTENSIONS = ['png', 'jpeg', 'jpg', 'pdf'];
